// extracted by mini-css-extract-plugin
export default {"back":"BackButton_back__T6IU8","back__darkTheme":"BackButton_back__darkTheme__bIBZQ"};